function timeLeft(expiry) {
  if (!expiry) return '∞';
  const diff = new Date(expiry) - new Date();
  if (diff <= 0) return 'Expiré';
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  if (h > 24) return `${Math.floor(h/24)}j ${h%24}h`;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleString('fr-FR', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' });
}

export default function DecisionTable({ decisions, loading, onUnban }) {
  const th = {
    padding: '0.6rem 1rem',
    textAlign: 'left',
    fontFamily: 'var(--font-mono)',
    fontSize: '0.7rem',
    color: 'var(--muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid var(--border)',
    whiteSpace: 'nowrap',
  };

  const td = {
    padding: '0.75rem 1rem',
    borderBottom: '1px solid var(--border)',
    fontFamily: 'var(--font-mono)',
    fontSize: '0.82rem',
    verticalAlign: 'middle',
  };

  if (loading) return (
    <div style={{ textAlign:'center', padding:'4rem', color:'var(--muted)', fontFamily:'var(--font-mono)' }}>
      Chargement…
    </div>
  );

  if (!decisions.length) return (
    <div style={{
      textAlign:'center', padding:'4rem',
      background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:'8px',
      color:'var(--muted)', fontFamily:'var(--font-mono)',
    }}>
      ✅ Aucun ban actif
    </div>
  );

  return (
    <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:'8px', overflow:'hidden' }}>
      <div style={{ overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              <th style={th}>IP</th>
              <th style={th}>Pays</th>
              <th style={th}>Instance</th>
              <th style={th}>Raison / Scénario</th>
              <th style={th}>Bans</th>
              <th style={th}>Banni le</th>
              <th style={th}>Expire dans</th>
              <th style={{ ...th, textAlign:'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {decisions.map((d, i) => (
              <tr key={d.id || i}
                onMouseOver={e => e.currentTarget.style.background = 'var(--bg3)'}
                onMouseOut={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={td}>
                  <span style={{ color:'var(--accent2)', fontWeight:600 }}>{d.value}</span>
                </td>
                <td style={td}>
                  <CountryCell cc={d.country} />
                </td>
                <td style={td}>
                  <InstanceCell instance={d.instance} machine={d.machine_id} />
                </td>
                <td style={{ ...td, maxWidth:'260px' }}>
                  <span style={{ color:'var(--text)', wordBreak:'break-all', fontSize:'0.78rem' }}>
                    {d.scenario || d.reason || '—'}
                  </span>
                </td>
                <td style={td}>
                  <span style={{
                    background: 'rgba(232,71,63,0.15)',
                    color: 'var(--accent)',
                    borderRadius: '4px',
                    padding: '0.15rem 0.5rem',
                    fontWeight: 700,
                  }}>{d.events_count ?? 1}</span>
                </td>
                <td style={{ ...td, color:'var(--muted)' }}>
                  {formatDate(d.start_at || d.created_at)}
                </td>
                <td style={td}>
                  <ExpiryBadge expiry={d.until} duration={d.duration} />
                </td>
                <td style={{ ...td, textAlign:'right' }}>
                  <button onClick={() => onUnban(d)} style={{
                    background: 'transparent',
                    border: '1px solid var(--border)',
                    color: 'var(--muted)',
                    borderRadius: 'var(--radius)',
                    padding: '0.3rem 0.8rem',
                    fontFamily: 'var(--font-ui)',
                    fontWeight: 600,
                    fontSize: '0.78rem',
                    cursor: 'pointer',
                    transition: 'border-color 0.15s, color 0.15s',
                  }}
                    onMouseOver={e => { e.currentTarget.style.borderColor='var(--accent)'; e.currentTarget.style.color='var(--accent)'; }}
                    onMouseOut={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.color='var(--muted)'; }}
                  >
                    Débloquer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'0.75rem 1rem', borderTop:'1px solid var(--border)', fontFamily:'var(--font-mono)', fontSize:'0.7rem', color:'var(--muted)' }}>
        {decisions.length} décision{decisions.length > 1 ? 's' : ''} active{decisions.length > 1 ? 's' : ''}
      </div>
    </div>
  );
}

function InstanceCell({ instance, machine }) {
  if (instance) return (
    <div>
      <span style={{ fontFamily:'var(--font-mono)', fontSize:'0.78rem', background:'rgba(232,71,63,0.1)', color:'var(--accent2)', borderRadius:'4px', padding:'0.15rem 0.5rem', display:'block', wordBreak:'break-all' }}>
        {instance}
      </span>
      {machine && <span style={{ fontFamily:'var(--font-mono)', fontSize:'0.68rem', color:'var(--muted)', marginTop:'0.2rem', display:'block' }}>{machine}</span>}
    </div>
  );
  if (machine) return (
    <span style={{ fontFamily:'var(--font-mono)', fontSize:'0.78rem', color:'var(--muted)' }}>{machine}</span>
  );
  return <span style={{ color:'var(--muted)' }}>—</span>;
}

function CountryCell({ cc }) {
  if (!cc) return <span style={{ color:'var(--muted)' }}>—</span>;
  return (
    <div style={{ display:'flex', alignItems:'center', gap:'0.5rem' }}>
      <img
        src={`https://flagcdn.com/20x15/${cc.toLowerCase()}.png`}
        alt={cc}
        style={{ width:20, height:15, borderRadius:2 }}
        onError={e => e.target.style.display='none'}
      />
      <span>{cc}</span>
    </div>
  );
}

function ExpiryBadge({ expiry, duration }) {
  if (!expiry && !duration) return <span style={{ color:'var(--muted)' }}>∞</span>;
  if (expiry) {
    const left = timeLeft(expiry);
    const isExpired = left === 'Expiré';
    return (
      <span style={{ fontWeight:600, color: isExpired ? 'var(--muted)' : 'var(--green)' }}>
        {left}
      </span>
    );
  }
  // Fallback : afficher la duree brute
  return <span style={{ color:'var(--muted)', fontSize:'0.75rem' }}>{duration}</span>;
}
